

export function flatenCategories(obj, level) {
  const arr = [];
  const {
    children,
    ...rest
  } = obj;
  arr.push({
    value: rest.id,
    name: rest.name,
    html: `${new Array(level).join("&nbsp;&nbsp;")} ${rest.name}`,
    originalElement: obj
  });
  if (!children || !children.length) return arr;

  children.forEach(child => {
    arr.push(...flatenCategories(child, level + 1));
  });

  return arr;
}



export function changePositionName(item) {
  if(!item.name) return ``
  switch (item.name) {
    case "finishers":
      return "Robotnik wykończeniowy";

    case "electric":
      return "Elektryk";

    case "sanitary":
      return "Hydraulik";

    case "ground":
      return "Podłogarz";

    case "extra":
      return "Prace dodatkowe";

      default:
      return;
  }
}

export function searchRecursivelyArray(items, key, value) {
  if (!items) {
    return [];
  }
  for (const item of items) {
    // Test current object
    if (item[key] === value) {
      return item;
    }
    // Test children recursively
    const child = searchRecursivelyArray(item.children, key, value);
    if (child) {
      return child;
    }
  }
}

export function createDateAsUTC(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}

export function dateToIsoString(date) {
  return date.getFullYear() + '-' + (((date.getMonth() + 1) + "").padStart(2, 0)) + '-' + ((date.getDate() + "").padStart(2, 0));
}
